export enum SortUsersBy {
    NoSort = 'noSort',
    ReportedWork = 'reportedWork',
    SurnameAndName = 'surnameAndName',
    WorkingTimeSize = 'workingTimeSize',
}
